<template>
  <div class="q-mt-xl">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :filter="filtro"
      color="primary"
      title="Grupos Já com regra para a Função"
      title-class="text-brand-5 text-weight-bold"
      :rows="rows"
      class="tabela-tamanho-fixo"
      dense
      :columns="columns"
      row-key="id"
      :loading="disable"
      v-model:pagination="pagination"
      hide-pagination
    >
      <template v-slot:top-right>
        <q-input
          outlined
          rounded
          dense
          debounce="500"
          v-model="filtro"
          placeholder="Buscar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template #body-cell-nome="props">
        <q-td class="text-brand-5 text-weight-bold" :props="props">
          {{ props.row.name }}
        </q-td>
      </template>
      <template #body-cell-minimo="props">
        <q-td>
          <div v-if="typeEdit == true">
            <q-input dense outlined v-model="props.row.pivot.minimum_days" />
          </div>
          <span v-else>{{ props.row.pivot.minimum_days }}</span>
        </q-td>
      </template>
      <template #body-cell-maximo="props">
        <q-td>
          <div v-if="typeEdit == true">
            <q-input dense outlined v-model="props.row.pivot.maximum_days" />
          </div>
          <span v-else>{{ props.row.pivot.maximum_days }}</span>
        </q-td>
      </template>
      <template #body-cell-amount="props">
        <q-td>
          <div v-if="typeEdit == true">
            <q-input dense outlined v-model="props.row.pivot.max_amount" />
          </div>
          <span v-else>{{ props.row.pivot.max_amount }}</span>
        </q-td>
      </template>
      <template #body-cell-control="props">
        <q-td>
          <div v-if="typeEdit == true">
            <q-select
              :options="critico"
              dense
              outlined
              label="Critico"
              v-model="regras"
              :rules="[(val) => val || 'Campo Obrigatório']"
            />
          </div>
          <span v-else>{{ props.row.pivot.control_types }}</span>
        </q-td>
      </template>

      <template #body-cell-critico="props">
        <q-td>
          <span v-if="props.row.pivot.critico == 1">Sim</span>
          <span v-else>Não</span>
        </q-td>
      </template>

      <template #body-cell-editar="props">
        <q-td>
          <q-btn
            v-if="typeEdit == false"
            @click="typeEdit = !typeEdit"
            color="primary"
            round
            flat
            icon="edit"
          />
          <q-btn
            v-else
            @click="editar(props.row)"
            color="positive"
            round
            icon="check"
            flat
          />
        </q-td>
      </template>
      <template #body-cell-deletar="props">
        <q-td>
          <q-btn
            @click="deletar(props.row.id)"
            color="negative"
            round
            icon="delete"
            flat
          />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "nome",
    label: "Descrição",
    align: "left",
    field: "name",
  },
  {
    name: "critico",
    label: "Critico",
    align: "left",
  },
  {
    name: "minimo",
    label: "Prazo Min.",
    align: "left",
  },
  {
    name: "maximo",
    label: "Prazo Máx.",
    align: "left",
  },
  {
    name: "amount",
    label: "Quantidade",
    align: "left",
  },
  {
    name: "control",
    label: "Tipo Controle",
    align: "left",
  },

  {
    name: "editar",
    label: "Editar",
    align: "left",
  },
  {
    name: "deletar",
    label: "Deletar",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
export default {
  setup() {
    const $q = useQuasar();
    const store = useStore();
    const rows = ref([]);
    const disable = ref(true);
    const filtro = ref("");
    const route = useRoute();
    const dados = route.params.id;
    const typeEdit = ref(false);
    const regras = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getFuncaoGrupos = async () => {
      disable.value = true;
      let response = await store.dispatch("processos/funcaoGrupo", {
        unidade: store.state.org.unidadeData.id,
        id: dados,
      });

      rows.value = response.data.result.product_group;
      let array = response.data.result.product_group.filter((grupo) => {
        return grupo?.name
          ?.toLocaleLowerCase()
          ?.includes(filtro.value?.toLocaleLowerCase());
      });

      rows.value = [...array];

      disable.value = false;
    };

    onMounted(getFuncaoGrupos);

    const handleRequest = async () => {
      getFuncaoGrupos(pagination.value.page, pagination.value.rowsPerPage);
    };

    const editar = async (value) => {
      try {
        await store.dispatch("processos/editarFuncaoRegras", {
          unidade: store.state.org.unidadeData.id,
          id: value.id,
          maximum_days: value.pivot.maximum_days,
          minimum_days: value.pivot.minimum_days,
          control_types: regras.value.value,
          amount: value.pivot.max_amount,
          function_id: dados,
        });

        $q.notify({
          message: "editado com sucesso sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getFuncaoGrupos();
        typeEdit.value = false;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o editar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const deletar = async (id) => {
      try {
        await store.dispatch("processos/funcaoGrupoDeletar", {
          funcao_id: id,
          id: dados,
        });

        $q.notify({
          message: "removido com sucesso sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getFuncaoGrupos();
      } catch (error) {
        $q.notify({
          message: "Erro a o remover",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getFuncaoGrupos();
      }
    );

    watch(
      () => filtro.value,
      () => {
        getFuncaoGrupos();
      }
    );

    return {
      columns,
      rows,
      getFuncaoGrupos,
      pagination,
      handleRequest,
      disable,
      filtro,
      editar,
      typeEdit,
      deletar,
      regras,
      critico: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "EMAIL E STATUS TROCA (WEB)",
          value: "ambos",
        },
        {
          label: "NENHUM",
          value: "nenhum",
        },
        {
          label: "SOMENTE EMAIL",
          value: "email",
        },
        {
          label: "SOMENTE STATUS TROCA (WEB)",
          value: "farol",
        },
      ],
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
